export default __webpack_public_path__ + "static/media/685.d1da0228.jpg";